import Header from "./components/Header";
import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import Zones from "./components/Zones";
import Collection from "./components/Collection";
import FeatureArticles from "./components/FeatureArticles";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main>
        <Hero />
        <HotBoard />
        <Zones />
        <Collection />
        <FeatureArticles />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}